import React, { useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import {
  AppBar, Avatar, Box, IconButton, Menu, MenuItem, Stack, Toolbar, Typography, Chip,
} from "@mui/material";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import LogoutIcon from "@mui/icons-material/Logout";
import { BRAND } from "../theme";
import { useAuth } from "../auth/AuthContext";

/** Platform Super Admin shell (Phase D). */
const SuperAdminLayout: React.FC = () => {
  const navigate = useNavigate();
  const { username, logout } = useAuth();
  const [anchor, setAnchor] = useState<null | HTMLElement>(null);
  const name = username || "Super Admin";

  return (
    <Box sx={{ bgcolor: BRAND.surface, minHeight: "100vh" }}>
      <AppBar position="sticky" elevation={0} color="inherit"
        sx={{ bgcolor: "#101826", borderBottom: "1px solid", borderColor: "rgba(255,255,255,.08)" }}>
        <Toolbar sx={{ gap: 1 }}>
          <Stack direction="row" alignItems="center" spacing={1} sx={{ color: "#fff", cursor: "pointer" }}
            onClick={() => navigate("/admin/tenants")}>
            <AdminPanelSettingsIcon />
            <Typography variant="h6" sx={{ color: "#fff" }}>Platform Admin</Typography>
          </Stack>
          <Chip label="PLATFORM_SUPER_ADMIN" size="small"
            sx={{ ml: 1, bgcolor: "rgba(255,255,255,.12)", color: "#fff", fontWeight: 700, display: { xs: "none", sm: "flex" } }} />
          <Box sx={{ flex: 1 }} />
          <IconButton onClick={(e) => setAnchor(e.currentTarget)} sx={{ gap: 1 }}>
            <Avatar sx={{ width: 32, height: 32, bgcolor: "#2b6cb0" }}>{name.slice(0, 1).toUpperCase()}</Avatar>
          </IconButton>
          <Menu anchorEl={anchor} open={!!anchor} onClose={() => setAnchor(null)}>
            <MenuItem onClick={logout}><LogoutIcon fontSize="small" style={{ marginRight: 8 }} />Sign out</MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>
      <Box sx={{ p: { xs: 2, md: 3 }, maxWidth: 1200, mx: "auto" }}><Outlet /></Box>
    </Box>
  );
};

export default SuperAdminLayout;
